const convertDateToLocaleString = (type: 'date' | 'dateTime', date: string, locale: string) => {
  if (type === 'date') {
    return new Date(date).toLocaleDateString(locale);
  }

  return new Date(date).toLocaleString(locale);
};

export default convertDateToLocaleString;
